export * from "./TranscribedSuccess";
export * from "./TranscriptionFailed";
export * from "./Transcribing";

export enum eTranscriptionStatusType {
  SUCCESS = "success",
  ERROR = "error",
  TRANSCRIBING = "transcribing",
  WAITING = "waiting",
}
